/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sync_Twda_LabelInputs */



/**
* | output |
* | --- |
* | "Import TWDA decks" |
*
* @param {Admin_Sync_Twda_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_sync_twda_label = /** @type {((inputs?: Admin_Sync_Twda_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sync_Twda_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer les decks TWDA")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar mazos de la TWDA")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Importar decks da TWDA")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa i deck della TWDA")
	return /** @type {LocalizedString} */ ("Import TWDA decks")
});